import RelationTypesScene from '../scenes/RelationTypesScene';

const routes = [
  {
    path: '/relation-types/*',
    component: RelationTypesScene,
    exact: false,
    menuName: 'relationTypes_plural',
    hasRight: 'RELATIONTYPES.MANAGE.ALL',
  },
];

export default routes;
